import React, { ReactNode } from 'react';
export type Tone = 'navy' | 'white' | 'mist';
type SectionProps = {
  number: string;
  title: string;
  kicker?: string;
  lede?: string;
  tone: Tone;
  children: ReactNode;
};
const toneStyles: Record<Tone, {
  wrap: string;
  title: string;
  chip: string;
  kicker: string;
  lede: string;
  rule: string;
}> = {
  navy: {
    wrap: 'bg-navy-deep text-white',
    title: 'text-white',
    chip: 'bg-white/8 text-white/70 border-white/15',
    kicker: 'text-green',
    lede: 'text-white/60',
    rule: 'bg-white/10'
  },
  white: {
    wrap: 'bg-white text-ink',
    title: 'text-navy',
    chip: 'bg-mist text-ink-muted border-line',
    kicker: 'text-green-deep',
    lede: 'text-ink-muted',
    rule: 'bg-line'
  },
  mist: {
    wrap: 'bg-mist text-ink',
    title: 'text-navy',
    chip: 'bg-white text-ink-muted border-line',
    kicker: 'text-green-deep',
    lede: 'text-ink-muted',
    rule: 'bg-line'
  }
};
export function Section({
  number,
  title,
  kicker,
  lede,
  tone,
  children
}: SectionProps) {
  const s = toneStyles[tone];
  return <section className={`w-full ${s.wrap}`} data-id="element-48" data-mp="2zi7lif551mcy">
      <div className="mx-auto w-[1200px] px-20 py-24" data-id="element-49" data-mp="2uma6qd9iwo2a">
        <div className="flex items-center gap-4" data-id="element-50" data-mp="2ujnzkeqjoakl">
          <span className={`tabular inline-flex h-7 items-center rounded-md border px-2.5 font-display text-[13px] font-semibold ${s.chip}`} data-id="element-51" data-mp="38dxbz2lg16x7">
            {number}
          </span>
          {kicker ? <>
              <span className="accent-rule h-px w-8" aria-hidden="true" data-id="element-52" data-mp="3icwdm17sk2ap" />
              <span className={`font-sans text-[11px] font-semibold uppercase tracking-[0.18em] ${s.kicker}`} data-id="element-53" data-mp="3dbgp1z6endnk">
                {kicker}
              </span>
            </> : null}
        </div>

        <div className="mt-6 flex items-end justify-between gap-16" data-id="element-54" data-mp="1wxqlctj76reg">
          <h2 className={`font-display text-[42px] font-semibold leading-[1.08] tracking-[-0.025em] ${s.title}`} data-id="element-55" data-mp="1wy0e2ovmncnu">
            {title}
          </h2>
          {lede ? <p className={`max-w-[440px] pb-1 font-sans text-[15px] leading-[1.7] ${s.lede}`} data-id="element-56" data-mp="3s2g84rrgj6tb">
              {lede}
            </p> : null}
        </div>

        <div className={`mt-10 h-px w-full ${s.rule}`} aria-hidden="true" data-id="element-57" data-mp="5tf9rcyuke7r" />
        <div className="mt-12" data-id="element-58" data-mp="asrspmmll152">{children}</div>
      </div>
    </section>;
}